module.exports = "<div class=\"container\" id=\"main-error-box\">\r\n    <div class=\"mainbox col-lg-12\">\r\n        <div class=\"error\">404</div>\r\n        <div class=\"message\">OOPS, SORRY WE CAN’T FIND THAT PAGE!</div>\r\n        <span class=\"small-message\">Either something went wrong or the page doesn’t exist anymore.</span>\r\n        <div class=\"backbutton\">\r\n            <a routerLink=\"/dashboard\" class=\"btn btn-marron btn-md\">Dashboard Page </a>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.html
// module id = ./src/app/components/not-found/not-found.component.html
// module chunks = main